import { format } from 'date-fns';
import { Formik } from 'formik';
import {
  Button,
  Grid,
  TextField,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import { Publish } from '@mui/icons-material';
import { publishSchema } from './constants';


const PublishDialog = ({ open, onClose, onPublish }) => (
  <Dialog 
    open={open} 
    onClose={onClose} 
    maxWidth="sm" 
    fullWidth
  >
    <DialogTitle>Publish to Operational Flights</DialogTitle>
    <Formik
      initialValues={{ fromDate: format(new Date(), 'yyyy-MM-dd'), toDate: '' }}
      validationSchema={publishSchema}
      onSubmit={onPublish}
    >
      {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
        <form onSubmit={handleSubmit}>
          <DialogContent dividers>
            <Alert severity="info" sx={{ mb: 2 }}>
              This will expand scheduled flight patterns in the selected date range
              into the operational flights collection. Existing records will not be overwritten.
            </Alert>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <TextField 
                  fullWidth 
                  label="From Date *" 
                  name="fromDate" 
                  type="date"
                  value={values.fromDate} 
                  onChange={handleChange} 
                  onBlur={handleBlur}
                  slotProps={{ inputLabel: { shrink: true } }}
                  error={touched.fromDate && Boolean(errors.fromDate)}
                  helperText={touched.fromDate && errors.fromDate} />
              </Grid>
              <Grid item xs={6}>
                <TextField 
                  fullWidth 
                  label="To Date *" 
                  name="toDate" 
                  type="date"
                  value={values.toDate} 
                  onChange={handleChange} 
                  onBlur={handleBlur}
                  slotProps={{ inputLabel: { shrink: true } }}
                  error={touched.toDate && Boolean(errors.toDate)}
                  helperText={touched.toDate && errors.toDate} />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button 
              variant="outlined" 
              color="secondary"
              onClick={onClose}
            >
              Cancel
            </Button>
            <Button 
              type="submit" 
              variant="contained" 
              color="success"
              startIcon={<Publish />} 
              disabled={isSubmitting}
            >
              Publish
            </Button>
          </DialogActions>
        </form>
      )}
    </Formik>
  </Dialog>
);

export default PublishDialog;
